(function () {

  /* ── Move #mgq-stage to body so Ella wrappers can't clip it ── */
  var stage = document.getElementById('mgq-stage');
  if (stage && stage.parentNode !== document.body) {
    document.body.appendChild(stage);
  }

  /* Also move fixed UI elements to body */
  ['mgq-cursor','mgq-cursor-ring','mgq-progress','mgq-badge',
   'mgq-mute','mgq-scroll-hint','mgq-back-btn','mgq-loader'].forEach(function(id){
    var el = document.getElementById(id);
    if (el && el.parentNode !== document.body) document.body.appendChild(el);
  });

  /* ── CONFIG ── */
  var FREEZES            = window.MGQ_FREEZES            || [10,25,42,60,80];
  var ADVANCE_MS         = window.MGQ_ADVANCE_MS         || 3000;
  var FREEZE_TOL         = 0.5;
  var ENABLE_POST_SUBMIT = window.MGQ_ENABLE_POST_SUBMIT !== false;
  var ENABLE_PAUSES      = window.MGQ_ENABLE_PAUSES      !== false;
  var ENABLE_PAUSE_TEXT  = window.MGQ_ENABLE_PAUSE_TEXT  !== false;

  /* Filter out any freeze at 0 or beyond video length */
  FREEZES = FREEZES.filter(function(t){ return t > 0; });

  /* ── MOBILE ── */
  var isMobile = window.innerWidth < 768;
  function resolveVideoSrc(el) {
    if (!el) return;
    var src = isMobile
      ? (el.dataset.srcMobile || el.dataset.srcDesktop)
      : (el.dataset.srcDesktop || el.dataset.srcMobile);
    if (src && src.trim()) { el.setAttribute('src', src); el.load(); }
  }
  function resolveAllVideos() {
    isMobile = window.innerWidth < 768;
    document.querySelectorAll('#mgq-stage video').forEach(resolveVideoSrc);
  }
  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(resolveAllVideos, 300);
  });

  /* ── STATE ── */
  var freezeIdx    = -1;
  var frozen       = false;
  var unlocked     = false;
  var mgqMuted     = true;
  var advanceTimer = null;
  var rafId;
  var countdownRaf;

  var vid     = document.getElementById('mgq-video');
  var bar     = document.getElementById('mgq-progress');
  var badge   = document.getElementById('mgq-badge');
  var muteBtn = document.getElementById('mgq-mute');

  /* ── SHOW SECTION ── */
  function showOnly(id) {
    document.querySelectorAll('#mgq-stage .mgq-sec').forEach(function (s) {
      s.style.opacity = '0';
      s.style.pointerEvents = 'none';
    });
    var el = typeof id === 'string' ? document.getElementById(id) : id;
    if (el) {
      el.style.opacity = '1';
      el.style.pointerEvents = 'all';
    }
  }

  /* ── END CARDS ── */
  function hideAllCards() {
    document.querySelectorAll('#mgq-s-player .mgq-end-card').forEach(function (c) {
      c.style.opacity = '0';
      c.style.pointerEvents = 'none';
    });
  }
  function showCard(idx) {
    hideAllCards();
    var card = document.getElementById('mgq-end-card-' + (idx + 1));
    if (card) {
      card.style.opacity = '1';
      card.style.pointerEvents = 'all';
    }
  }

  /* ── PROGRESS ── */
  function startProgress() {
    cancelAnimationFrame(rafId);
    function tick() {
      if (vid && vid.duration && bar) bar.style.width = (vid.currentTime / vid.duration * 100) + '%';
      rafId = requestAnimationFrame(tick);
    }
    rafId = requestAnimationFrame(tick);
  }

  /* ── COUNTDOWN RING ── */
  var ring = document.getElementById('mgq-countdown-ring');
  var countdownEl = document.getElementById('mgq-countdown');
  function startCountdown(ms) {
    if (!ring || !countdownEl) return;
    cancelAnimationFrame(countdownRaf);
    countdownEl.style.opacity = '1';
    var start = performance.now();
    function tick(now) {
      var pct = Math.min((now - start) / ms, 1);
      ring.setAttribute('stroke-dashoffset', 113 * (1 - pct));
      if (pct < 1) countdownRaf = requestAnimationFrame(tick);
      else countdownEl.style.opacity = '0';
    }
    countdownRaf = requestAnimationFrame(tick);
  }
  function stopCountdown() {
    cancelAnimationFrame(countdownRaf);
    if (countdownEl) countdownEl.style.opacity = '0';
    if (ring) ring.setAttribute('stroke-dashoffset', '113');
  }

  /* ── FREEZE ── */
  function doFreeze(idx) {
    if (!ENABLE_PAUSES) return;
    if (frozen && freezeIdx === idx) return;
    frozen = true; freezeIdx = idx;
    vid.pause();
    vid.currentTime = FREEZES[idx];
    cancelAnimationFrame(rafId);
    if (bar) bar.style.width = (FREEZES[idx] / vid.duration * 100) + '%';
    if (ENABLE_PAUSE_TEXT) showCard(idx);
    if (badge) { badge.textContent = '0'+(idx+1)+' / 0'+FREEZES.length; badge.style.opacity='1'; }
    startCountdown(ADVANCE_MS);
    if (advanceTimer) clearTimeout(advanceTimer);
    advanceTimer = setTimeout(doAdvance, ADVANCE_MS);
  }

  /* ── ADVANCE ── */
  function doAdvance() {
    if (!frozen) return;
    stopCountdown();
    hideAllCards();
    frozen = false;
    var next = freezeIdx + 1;
    if (next >= FREEZES.length) {
      showOnly('mgq-s-tf');
      if (muteBtn) muteBtn.classList.remove('show');
      cancelAnimationFrame(rafId);
      resolveRsvpVideo();
      return;
    }
    vid.play().catch(function () {});
    startProgress();
  }

  /* ── NAVIGATE FORWARD ── */
  function navForward() {
    var player = document.getElementById('mgq-s-player');
    if (!player || player.style.opacity === '0' || player.style.opacity === '') return;
    if (advanceTimer) { clearTimeout(advanceTimer); advanceTimer = null; }
    stopCountdown();
    if (frozen) {
      doAdvance();
    } else {
      var next = freezeIdx + 1;
      if (next < FREEZES.length) {
        vid.currentTime = FREEZES[next] - FREEZE_TOL;
        vid.play().catch(function () {});
        startProgress();
      }
    }
  }

  /* ── NAVIGATE BACK ── */
  function navBack() {
    var player = document.getElementById('mgq-s-player');
    if (!player || player.style.opacity === '0' || player.style.opacity === '') return;
    if (advanceTimer) { clearTimeout(advanceTimer); advanceTimer = null; }
    stopCountdown();
    hideAllCards();
    frozen = false;
    var prev = freezeIdx - 1;
    if (prev < 0) {
      vid.pause(); vid.currentTime = 0;
      if (muteBtn) muteBtn.classList.remove('show');
      if (badge)   badge.style.opacity = '0';
      cancelAnimationFrame(rafId);
      showOnly('mgq-s-hero');
      return;
    }
    var seekTo = prev > 0 ? FREEZES[prev - 1] + 0.5 : 0;
    freezeIdx = prev - 1;
    vid.currentTime = seekTo;
    vid.play().catch(function () {});
    startProgress();
  }

  /* ── timeupdate ── */
  function onTimeUpdate() {
    if (!ENABLE_PAUSES || frozen || !vid.duration) return;
    var targetIdx = freezeIdx + 1;
    if (targetIdx >= FREEZES.length) return;
    if (vid.currentTime >= FREEZES[targetIdx] - FREEZE_TOL) doFreeze(targetIdx);
  }

  /* ── BEGIN ── */
  function begin() {
    showOnly('mgq-s-player');
    resolveVideoSrc(vid);
    vid.muted = mgqMuted;
    vid.currentTime = 0;
    freezeIdx = -1; frozen = false;
    if (muteBtn) muteBtn.classList.add('show');
    if (badge)   badge.style.opacity = '0';
    vid.play().catch(function () { vid.muted = true; vid.play(); });
    startProgress();
    vid.removeEventListener('timeupdate', onTimeUpdate);
    vid.addEventListener('timeupdate', onTimeUpdate);
    vid.onended = function () {
      hideAllCards(); stopCountdown();
      if (advanceTimer) { clearTimeout(advanceTimer); advanceTimer = null; }
      showOnly('mgq-s-tf');
      if (muteBtn) muteBtn.classList.remove('show');
      resolveRsvpVideo();
    };
  }

  /* ── RESOLVE RSVP VIDEO ── */
  function resolveRsvpVideo() {
    var rv = document.querySelector('.mgq-tf-vid');
    if (rv) { resolveVideoSrc(rv); rv.play().catch(function () {}); }
  }

  /* ── WHEEL ── */
  var wheelCooldown = false;
  document.addEventListener('wheel', function (e) {
    if (unlocked || wheelCooldown) return;
    wheelCooldown = true;
    setTimeout(function () { wheelCooldown = false; }, 500);
    if (e.deltaY > 0) navForward(); else navBack();
  }, { passive: true });

  /* ── TOUCH ── */
  var touchStartY = 0;
  document.addEventListener('touchstart', function (e) { touchStartY = e.touches[0].clientY; }, { passive: true });
  document.addEventListener('touchend', function (e) {
    if (unlocked) return;
    var diff = touchStartY - e.changedTouches[0].clientY;
    if (Math.abs(diff) < 40) return;
    if (diff > 0) navForward(); else navBack();
  }, { passive: true });

  /* ── INIT ── */
  function initShow() {
    /* hide Ella page chrome */
    ['header','#header','.site-header','.header-wrapper',
     'footer','.site-footer','.footer'].forEach(function(sel){
      var el = document.querySelector(sel);
      if (el && !el.closest('#mgq-stage')) el.style.display = 'none';
    });

    resolveAllVideos();

    /* hide ALL sections and ALL end cards so nothing intercepts clicks */
    document.querySelectorAll('#mgq-stage .mgq-sec').forEach(function(s){
      s.style.opacity = '0';
      s.style.pointerEvents = 'none';
    });
    document.querySelectorAll('#mgq-stage .mgq-end-card').forEach(function(c){
      c.style.opacity = '0';
      c.style.pointerEvents = 'none';
    });

    var loader = document.getElementById('mgq-loader');
    if (loader) loader.classList.add('hidden');
    showOnly('mgq-s-hero');
    setTimeout(function () {
      var hint = document.getElementById('mgq-scroll-hint');
      if (hint) hint.classList.add('show');
    }, 1000);
  }

  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    setTimeout(initShow, 200);
  } else {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(initShow, 200); });
  }
  setTimeout(initShow, 2000); /* hard fallback */

  /* ── CURSOR (desktop only) ── */
  if (!isMobile) {
    var cur = document.getElementById('mgq-cursor');
    var curRing = document.getElementById('mgq-cursor-ring');
    var rx = window.innerWidth/2, ry = window.innerHeight/2;
    document.addEventListener('mousemove', function (e) { rx=e.clientX; ry=e.clientY; });
    (function loop() {
      if (cur)     { cur.style.left=rx+'px'; cur.style.top=ry+'px'; }
      if (curRing) { curRing.style.left=rx+'px'; curRing.style.top=ry+'px'; }
      requestAnimationFrame(loop);
    })();
  }

  /* ── UNLOCK ── */
  window.mgqUnlock = function () {
    if (unlocked) return;
    unlocked = true;
    if (advanceTimer) { clearTimeout(advanceTimer); advanceTimer = null; }
    stopCountdown(); hideAllCards();
    if (vid) vid.pause();
    cancelAnimationFrame(rafId);
    if (muteBtn) muteBtn.classList.remove('show');
    showOnly('mgq-s-ty');
  };
  window.addEventListener('message', function (e) {
    if (typeof e.data==='string' && e.data.indexOf('form-submit')>-1) window.mgqUnlock();
    if (e.data && e.data.type==='form-submit') window.mgqUnlock();
  });
  document.addEventListener('mgq:rsvp-complete', function () {
    if (ENABLE_POST_SUBMIT) window.mgqUnlock();
  });

  /* ── UNLOCK VIDEO ── */
  function goToUnlockVideo() {
    var uvSec = document.getElementById('mgq-s-uv');
    var uvVid = document.getElementById('mgq-v-unlock');
    if (uvSec && uvVid) {
      resolveVideoSrc(uvVid);
      showOnly('mgq-s-uv');
      uvVid.muted=mgqMuted; uvVid.loop=false; uvVid.currentTime=0;
      if (muteBtn) muteBtn.classList.add('show');
      uvVid.play().catch(function(){uvVid.muted=true;uvVid.play();});
      uvVid.onended = function(){ if(muteBtn) muteBtn.classList.remove('show'); goToChoice(); };
    } else goToChoice();
  }

  /* ── CHOICE ── */
  function goToChoice() {
    ['mgq-v-a','mgq-v-b','mgq-v-agb','mgq-v-bgb'].forEach(function(id){
      var v=document.getElementById(id); if(v) v.pause();
    });
    var back=document.getElementById('mgq-back-btn');
    if(back) back.classList.remove('show');
    if(muteBtn) muteBtn.classList.remove('show');
    showOnly('mgq-s-choice');
  }

  /* ── BRANCH — play branch video then show banner ── */
  function goToBranch(branch) {
    var secId  = branch==='a' ? 'mgq-s-av'  : 'mgq-s-bv';
    var vidEl  = document.getElementById(branch==='a' ? 'mgq-v-a' : 'mgq-v-b');
    var banner = branch==='a' ? 'mgq-s-ab'  : 'mgq-s-bb';
    var back   = document.getElementById('mgq-back-btn');
    if (vidEl) {
      resolveVideoSrc(vidEl);
      showOnly(secId);
      vidEl.muted=mgqMuted; vidEl.loop=false; vidEl.currentTime=0;
      if(muteBtn) muteBtn.classList.add('show');
      if(back) back.classList.remove('show');
      vidEl.play().catch(function(){vidEl.muted=true; vidEl.play();});
      vidEl.onended = function() {
        if(muteBtn) muteBtn.classList.remove('show');
        showOnly(banner);
      };
    } else {
      /* no video — go straight to banner */
      showOnly(branch==='a' ? 'mgq-s-ab' : 'mgq-s-bb');
    }
  }

  /* ── GO BACK FROM BRANCH — play go-back video then return to choice ── */
  function goBackFromBranch(branch) {
    var gbSecId = branch==='a' ? 'mgq-s-agb'  : 'mgq-s-bgb';
    var gbVid   = document.getElementById(branch==='a' ? 'mgq-v-agb' : 'mgq-v-bgb');
    var gbSec   = document.getElementById(gbSecId);
    if (gbSec && gbVid && (gbVid.dataset.srcDesktop || gbVid.dataset.srcMobile)) {
      resolveVideoSrc(gbVid);
      showOnly(gbSecId);
      gbVid.muted=mgqMuted; gbVid.loop=false; gbVid.currentTime=0;
      if(muteBtn) muteBtn.classList.add('show');
      gbVid.play().catch(function(){gbVid.muted=true; gbVid.play();});
      gbVid.onended = function() {
        if(muteBtn) muteBtn.classList.remove('show');
        goToChoice();
      };
    } else {
      /* no go-back video — jump straight to choice */
      goToChoice();
    }
  }

  /* ── MUTE ── */
  if (muteBtn) {
    muteBtn.addEventListener('click', function () {
      mgqMuted = !mgqMuted;
      document.querySelectorAll('#mgq-stage video').forEach(function(v){v.muted=mgqMuted;});
      muteBtn.textContent = mgqMuted?'♪':'♫';
    });
  }

  /* ── BUTTON DELEGATION ── */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-action="nav-forward"]')) { navForward(); return; }
    if (e.target.closest('[data-action="nav-back"]'))    { navBack();    return; }
    var btn = e.target.closest('[data-action]');
    if (!btn) return;
    var a = btn.dataset.action;
    if      (a==='begin')           begin();
    else if (a==='go-unlock-video') goToUnlockVideo();
    else if (a==='go-choice')            goToChoice();
    else if (a==='go-branch')            goToBranch(btn.dataset.branch);
    else if (a==='go-back-from-branch')  goBackFromBranch(btn.dataset.branch);
    else if (a==='go-section')      { var t=btn.dataset.target; if(t) showOnly(t); }
  });

  /* keep body scrollable so wheel fires */
  document.body.style.overflowY = 'scroll';
  document.body.style.height    = '200vh';
  document.documentElement.classList.add('mgq-active');

})();